import { useState } from 'react';
import { PhoneValidationStep } from '@app/pages/Phone/PhoneValidationStep';
import { useValidatePhoneValidationCodeAction } from '@actions/ValidatePhoneValidationCodeAction';
import { useSendPhoneValidationCodeAction } from '@actions/SendPhoneValidationCodeAction';
import { useNavigate } from 'react-router-dom';

export const usePhonePageController = () => {
  const [step, setStep] = useState<number>(PhoneValidationStep.EnterPhoneNumber);
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const { mutateAsync: validateCodeAction } = useValidatePhoneValidationCodeAction();
  const { mutateAsync: sendCodeAction } = useSendPhoneValidationCodeAction();
  const navigator = useNavigate();

  const resetError = () => {
    setError(false);
    setErrorMessage(null);
  };
  const onPhoneNumberChange = async (number: string) => {
    setPhoneNumber(number);
    await sendCodeAction(number);
    setStep(PhoneValidationStep.ValidatePhoneNumber);
  };
  const onCodeComplete = async (code: string) => {
    const result = await validateCodeAction({ phoneNumber, code });
    if (result.statusCode && (result.statusCode === 500 || result.statusCode === 400)) {
      setError(true);
      setErrorMessage(result.message);
      return;
    }
    navigator('/groups');
  };
  const onTryAgain = () => {
    setStep(PhoneValidationStep.EnterPhoneNumber);
    setPhoneNumber('');
  };
  const onTryDifferentNumber = () => {
    setStep(PhoneValidationStep.EnterPhoneNumber);
    setPhoneNumber('');
  };
  const onResendCode = async () => {
    await sendCodeAction(phoneNumber);
  };
  return {
    resetError,
    error,
    errorMessage,
    step,
    phoneNumber,
    onPhoneNumberChange,
    onCodeComplete,
    onTryAgain,
    onTryDifferentNumber,
    onResendCode,
  };
};
